import { Audio } from './Audio_howl.class';

interface AudioPoolEntry {
  audio: Audio;
  loadTask: Promise<boolean>;
  referenceCount: number;
}

export interface AudioLease {
  audio: Audio;
  loaded: Promise<boolean>;
  release(): void;
}

/**
 * 持有当前存活 SoundElement 的音频实例。
 * 阅读端页面离开预加载窗口时会销毁 SoundElement，进而从池中释放原生媒体资源。
 */
export class AudioPool {
  private readonly entries = new Map<string, AudioPoolEntry>();

  public acquire(resource: string, preferHtml5 = false): AudioLease {
    const key = `${preferHtml5 ? 'html5' : 'auto'}:${resource}`;
    let entry = this.entries.get(key);
    if (!entry) {
      const audio = new Audio();
      entry = {
        audio,
        loadTask: audio.load(resource, preferHtml5),
        referenceCount: 0
      };
      this.entries.set(key, entry);
    }

    entry.referenceCount += 1;
    let released = false;

    return {
      audio: entry.audio,
      loaded: entry.loadTask,
      release: () => {
        if (released) return;
        released = true;
        this.release(key, entry);
      }
    };
  }

  private release(key: string, entry: AudioPoolEntry): void {
    if (this.entries.get(key) !== entry) return;

    entry.referenceCount -= 1;
    if (entry.referenceCount > 0) return;

    this.entries.delete(key);
    entry.audio.destroy();
  }
}

export const audioPool = new AudioPool();
